import * as userAction from "../actions/udh.action";
const user = (
  state = {
    status: null,
    loading: false,
    error: null,
    agents: null,
  },
  action,
) => {
  switch (action.type) {
    case userAction.SEARCHUDHOFFICEAGENTS_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true,
        parserData: {},
      });
    case userAction.SEARCHUDHOFFICEAGENTS_SUCCESS:
      return Object.assign({}, state, {
        agents: action.agents,
        status: action.status,
        loading: false,
      });
    case userAction.SEARCHUDHOFFICEAGENTS_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    case userAction.SET_SEARCHUDHOFFICEAGENTS_DATA:
      return Object.assign({}, state, {
        searchData: action.searchData,
      });
    default:
      return state;
  }
};
export default user;
